import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { RanchDTO } from "../dtos/RanchDTO";
import { STALE_TIME_MEDIUM } from "../query/query.constants";
import { useQuery } from "@tanstack/vue-query";
import _ from "lodash";
import { computed } from "vue";
const RANCH_STALE_TIME = STALE_TIME_MEDIUM; // 5 minutes
export function useRanches() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["ranch"],
        queryFn: async () => (await seedgreenAPI.get("/v2/Ranch")).data,
        staleTime: RANCH_STALE_TIME,
        select: (data) => {
            try {
                return data?.map((ranch) => new RanchDTO(ranch)) ?? [];
            }
            catch (error) {
                console.error("query/ranch::select ERROR", error);
            }
        },
    });
    return {
        ranches: query.data,
        ranchesById: computed(() => _.keyBy(query.data.value ?? [], "id")),
        ...query,
    };
}
